import { Outlet, useOutletContext } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import Sidebar from 'components/layout/Sidebar';
import { BreadcrumbsRoute } from 'use-react-router-breadcrumbs';
import { Breadcrumb } from '../Breadcrumb';

export const SidebarLayout = ({ routes }: { routes?: BreadcrumbsRoute[] }) => {
  //@ts-expect-error fix later
  const { openSideBar, setOpenSideBar } = useOutletContext();

  return (
    <Stack direction="row" sx={{ width: '100%' }}>
      <Sidebar open={openSideBar} setOpen={setOpenSideBar} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Breadcrumb routes={routes} />
        <Outlet />
      </Box>
    </Stack>
  );
};
